<template>
  <div class="tuolele-main-box edit-group">
    <div class="tuolele-main-search">
      <el-input
        v-model="search.keyword"
        placeholder="请输入套餐名称/ID"
        clearable
        style="width: 220px; margin-right: 10px;"
        @keyup.enter.native="handleSearch"
        @clear="handleSearch"
      />
      <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
      <el-button type="primary" @click="addCombo">添加套餐</el-button>
      <el-button type="success" @click="deleteCombo">移除套餐</el-button>
      <el-button type="warning" @click="convetCombo">转移到新分组</el-button>
    </div>
    <div class="tuolele-main-content">
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="item_id" label="套餐ID" />
        <el-table-column prop="name" label="套餐名称" />
        <el-table-column prop="type_name" label="课时类型" />
        <el-table-column prop="item_count" label="套餐售价">
          <template slot-scope="scope">
            <span>￥{{ scope.row.total_price / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="item_count" label="套餐状态">
          <template slot-scope="scope">
            <span>{{ scope.row.is_delete == 0 ? "已开启" : "已关闭" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="limited_number"
          label="购买上限"
        />
        <el-table-column prop="grade_name" label="适用年级" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="comboDetails(scope.row)"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="套餐详情"
      :visible.sync="dialogVisible1"
      class="combo-details"
    >
      <div
        v-if="[3, 4].indexOf(parseInt(comboShow.item_type)) > -1"
        class="self-table"
      >
        <div class="table-name">套餐名称 {{ comboShow.name }}</div>
        <div class="table-content">
          <table>
            <thead>
              <tr>
                <td>套餐类型</td>
                <td>扣费方式</td>
                <td>套餐课时</td>
                <td>套餐实际销售价</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in comboShow.sku_set" :key="item.key">
                <td>{{ item.summary }}</td>
                <td>月扣</td>
                <td>{{ item.days }}天</td>
                <td>{{ comboShow.total_price / 100 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        v-if="[1, 2, 6, 7, 8, 9].indexOf(parseInt(comboShow.item_type)) > -1"
        class="self-table"
      >
        <div class="table-name">套餐名称 {{ comboShow.name }}</div>
        <div class="table-content">
          <table>
            <thead>
              <tr>
                <td>扣费方式</td>
                <td>套餐课时</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in comboShow.sku_set" :key="item.key">
                <td>{{ item.summary }}</td>
                <td>{{ item.days }}天</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        v-if="[10, 11, 12, 13].indexOf(parseInt(comboShow.item_type)) > -1"
        class="self-table"
      >
        <div class="table-name">套餐名称 {{ comboShow.name }}</div>
        <div class="table-content">
          <table>
            <thead>
              <tr>
                <td>扣费方式</td>
                <td>套餐课时</td>
                <td>套餐有效期</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in comboShow.sku_set" :key="item.key">
                <td>{{ item.summary }}</td>
                <td>{{ item.days }}天</td>
                <td>{{ comboShow.begin_time }}~{{ comboShow.end_time }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="配置大屏" :visible.sync="bShowDeivceMangeDialog" width="30%">
      <ConvertComboGroup :key="'update'+dialogConvertKey" :item="currentSelectItem" @successCBK="getList()" />
    </el-dialog>
  </div>
</template>
<script>

import ConvertComboGroup from './components/ConvertComboGroup'

export default {
  name: 'StoreSetting',
  components: {
    ConvertComboGroup
  },
  data() {
    return {
      dialogVisible1: false,
      dialogVisible2: false,
      search: {
        shop_name: '',
        team_name: '',
        keyword: ''
      },
      tableDataRaw: [],
      comboShow: {},
      team_id: '',
      tableData: [],
      multipleSelection: [],
      dialogConvertKey: 0,
      bShowDeivceMangeDialog: false,
      currentSelectItem: {}
    }
  },
  mounted() {
    this.team_id = this.$route.query.team_id
    this.getList()
  },
  methods: {
    getList() {
      this.$http.findItemTeams({ team_id: this.team_id }).then(res => {
        this.tableDataRaw = res.data || []
        this.handleSearch()
        this.bShowDeivceMangeDialog = false
      })
    },
    handleSearch() {
      const keyword = (this.search.keyword || '').trim()
      if (!keyword) {
        this.tableData = [...this.tableDataRaw]
        return
      }
      const lowerKeyword = keyword.toLowerCase()
      this.tableData = this.tableDataRaw.filter(row => {
        const itemId = String(row.item_id || '').toLowerCase()
        const name = String(row.name || '').toLowerCase()
        return itemId.includes(lowerKeyword) || name.includes(lowerKeyword)
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map(e => {
        return e.item_id
      })
    },
    addCombo() {
      this.$router.push({
        path: 'comboList',
        query: { team_id: this.team_id }
      })
    },
    deleteCombo() {
      if (this.multipleSelection.length == 0) {
        return
      }
      this.$http
        .delItemForTeam({
          team_id: this.team_id,
          item_id: this.multipleSelection.join(',')
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: '移除套餐成功'
          })
          this.getList()
        })
    },
    comboDetails(item) {
      this.comboShow = item
      this.dialogVisible1 = true
    },
    convetCombo() {
      if (this.multipleSelection.length == 0) {
        return
      }
      this.dialogConvertKey++
      this.currentSelectItem = {
        old_team_id: this.team_id,
        item_id: this.multipleSelection.join(',')
      }
      this.bShowDeivceMangeDialog = true
    }
  }
}
</script>
<style lang="scss">
.self-table {
  margin-top: 0 !important;
  .table-name {
    margin-bottom: 20px;
  }
}
</style>
